import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const items = [
  { 
    label: 'Overview', 
    href: '/dashboard/overview', 
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
  },
  { 
    label: 'Team', 
    href: '/dashboard/team', 
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
  },
  { 
    label: 'Logs', 
    href: '/dashboard/logs', 
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line></svg>
  },
  { 
    label: 'Health', 
    href: '/dashboard/health', 
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
  },
  { 
    label: 'Workspaces', 
    href: '/dashboard/workspaces', 
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
  },
  { 
    label: 'Profile', 
    href: '/dashboard/profile', 
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
  },
];

interface SidebarProps {
  workspaceName: string;
  projectName: string;
  userName: string;
  userRole: string;
}

export function Sidebar({ workspaceName, projectName, userName, userRole }: SidebarProps) {
  const brandLogoSrc = '/founderpulselogo.png';
  const location = useLocation();
  const navigate = useNavigate();

  function isActive(href: string) {
    if (href === '/dashboard/overview') {
      return location.pathname === href || location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(href);
  }

  return (
    <>
      <aside className="sidebar">
        <div className="brand-lockup brand-lockup--sidebar">
          <div className="brand-mark">
            <img className="brand-mark__image" src={brandLogoSrc} alt="FounderPulse logo" />
          </div>
          <div className="brand-copy">
            <span>FounderPulse</span>
            <strong>{workspaceName}</strong>
            <em>{projectName}</em>
          </div>
        </div>

        <div 
          className="sidebar-user" 
          onClick={() => navigate('/dashboard/profile')} 
          style={{ cursor: 'pointer' }}
          title="Go to Profile"
        >
          <div className="avatar">{userName.slice(0, 2).toUpperCase()}</div>
          <div>
            <div className="sidebar-user__name">{userName}</div>
            <div className="role-pill">{userRole}</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              onClick={() => navigate(item.href)}
              className={`sidebar-link${isActive(item.href) ? ' is-active' : ''}`}
            >
              <span className="sidebar-link__dot">{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <div className="sidebar-status">
          <span className="sidebar-status__dot" />
          <span>Extension connected</span>
        </div>
      </aside>

      <nav className="bottom-nav" aria-label="Mobile navigation">
        {items.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={() => navigate(item.href)}
            className={`bottom-nav__link${isActive(item.href) ? ' is-active' : ''}`}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
}
